// Section 7, 17 and 18: Seed reserve policy. Always keep next Spring's seed / Keep unless
// starvation (asks in the shortage dialog) / Eat freely (eaten before anyone goes short).
// Default: config.policies.defaults.seedReserve.
import type { Config } from '../../config';
import { noChangeCost, noProblem } from '../../core/content-helpers';
import { definePolicy, noModifiers } from '../../core/registry';

export function seedReserve(config: Config) {
  return definePolicy({
    id: 'seedReserve',
    label: 'Seed reserve',
    section: 'S18',
    group: 'rations',
    options: ['always-keep', 'keep-unless-starvation', 'eat-freely'],
    default: config.policies.defaults.seedReserve,
    modifierTargets: [],
    modifiers: noModifiers,
    changeCost: noChangeCost,
    affects(ctx, option) {
      return [
        {
          key: `policy.seedReserve.${option}`,
          params: { seed: Math.round(ctx.state.seedReserved * 10) / 10 },
        },
      ];
    },
    validate: noProblem,
  });
}
